import Paragraph from "@vfuk/core-paragraph";
import Spacing from "@vfuk/core-spacing";
import { Tabs } from "@vfuk/core-tabs";
import type { TabsProps } from "@vfuk/core-tabs";

import { CircleColorKey } from "../CircleColorKey";
import { Stack } from "../Stack";
import { LeftAlignTabs, RightAlignContent } from "./LeftAlignedTabsStyles";

interface LeftAlignedTabsProps extends TabsProps {
  colorKeys?: {
    status: string;
    color: "green" | "orange";
  }[];
}

export const LeftAlignedTabs = (props: LeftAlignedTabsProps) => (
  <LeftAlignTabs>
    <RightAlignContent>
      {props.colorKeys?.map(({ status, color }) => (
        <Spacing key={status} spacingLevel={{ right: 4 }}>
          <Stack>
            <Spacing spacingLevel={{ right: 2 }}>
              <CircleColorKey color={color} />
            </Spacing>
            <Paragraph>{status}</Paragraph>
          </Stack>
        </Spacing>
      ))}
    </RightAlignContent>
    <Tabs {...props} tabs={{ width: "fit" }} />
  </LeftAlignTabs>
);
